import React, { ReactElement } from 'react';
import { uniq } from 'lodash';
import AccordionTab from './accordion-tab';
import ModelInput from './inputs/model-input';
import { SectionConfig } from '../config';

type Props = {
  sections: SectionConfig[];
};

function Accordion(props: Props): ReactElement {
  const { sections } = props;

  const [expandedSections, setExpandedSections] = React.useState<string[]>([]);

  const onExpandChange = (name: string) => (
    event: unknown,
    isExpanded: boolean
  ): void => {
    if (isExpanded) {
      const newValues = expandedSections.slice();
      newValues.push(name);
      setExpandedSections(uniq(newValues));
    } else {
      const newValues = expandedSections.filter((s) => s !== name);
      setExpandedSections(newValues);
    }
  };

  return (
    <div className="accordion">
      {sections.map((s) => (
        <AccordionTab
          key={s.name}
          expanded={expandedSections.indexOf(s.name) !== -1}
          onChange={onExpandChange(s.name)}
          label={s.name}
        >
          <div className="inputs-list">
            {s.inputs.map((config) => {
              const key = typeof config === 'string' ? config : config.name;
              return (
                <div key={key} className="inputs-list__item">
                  <ModelInput config={config} />
                </div>
              );
            })}
          </div>
        </AccordionTab>
      ))}
    </div>
  );
}

export default Accordion;
